export enum CardContentLayout {
  FLOATING = 0,
  BOXED = 1,
}
